import { render, staticRenderFns } from "./individualReport.vue?vue&type=template&id=58ef2973"
import script from "./individualReport.vue?vue&type=script&lang=js"
export * from "./individualReport.vue?vue&type=script&lang=js"
import style0 from "./individualReport.vue?vue&type=style&index=0&id=58ef2973&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports